// utils/formatPhoneNumber.js

/**
 * Formats a phone number by trimming it, removing non-digits,
 * and ensuring it starts with '+1' if it has 10 digits.
 *
 * @param {string} phone - The input phone number.
 * @returns {string} - The formatted phone number.
 */
 export function formatPhoneNumber(phone) {
  const trimmed = phone.trim();
  const digits = trimmed.replace(/\D/g, '');
  // If exactly 10 digits and not already starting with '+1', prepend +1
  if (digits.length === 10 && !trimmed.startsWith('+1')) {
    return '+1' + digits;
  }
  return trimmed;
}
